import bambooReducers from "@/integrations/bamboo-hr/store/bambooReducers";
import deputyReducers from "@/integrations/deputy/store/deputyReducers";
import fyorinReducers from "@/integrations/fyorin/store/fyorinReducers";
import peoplesPensionReducers from "@/integrations/peoplePension/store/peoplesPensionReducers";
import smartPensionReducers from "@/integrations/smartPension/store/smartPensionReducers";
import quickbooksReducers from "@/integrations/quickbooks/store/quickbooksReducers";
import viftoReducers from "@/integrations/vifto/store/viftoReducers";
import workforceReducers from "@/integrations/workforce/store/workforceReducers";
import xeroReducers from "@/integrations/xero/store/xeroReducers";
import adminReducers from "./reducers/adminReducers";
import advisorReducers from "./reducers/advisorReducers";
import allowanceReducers from "./reducers/allowanceReducers";
import assetReducers from "./reducers/assetReducers";
import auditLogReducers from "./reducers/auditLogReducers";
import authenticationReducers from "./reducers/authenticationReducers";
import companyReducers from "./reducers/companyReducers";
import costCenterReducers from "./reducers/costCenterReducers";
import courseReducers from "./reducers/courseReducers";
import createAccountReducers from "./reducers/createAccountReducers";
import departmentReducers from "./reducers/departmentReducers";
import employeeReducers from "./reducers/employeeReducers";
import fssReportReducers from "./reducers/fssReportReducers";
import gradeReducers from "./reducers/gradeReducers";
import groupReducers from "./reducers/groupReducers";
import integrationReducers from "./reducers/integrationReducers";
import leaveAdjustmentReducers from "./reducers/leaveAdjustmentReducers";
import leaveReducers from "./reducers/leaveReducers";
import myReducers from "./reducers/myReducers";
import noteReducers from "./reducers/noteReducers";
import notificationReducers from "./reducers/notificationReducers";
import organisationReducers from "./reducers/organisationReducers";
import overtimeReducers from "./reducers/overtimeReducers";
import payPeriodReducers from "./reducers/payPeriodReducers";
import payScheduleReducers from "./reducers/payScheduleReducers";
import paymentReducers from "./reducers/paymentReducers";
import payrollReducers from "./reducers/payrollReducers";
import payslipReducers from "./reducers/payslipReducers";
import pensionReducers from "./reducers/pensionReducers";
import permissionReducers from "./reducers/permissionReducers";
import reportReducers from "./reducers/reportReducers";
import schemeReducers from "./reducers/schemeReducers";
import shiftReducers from "./reducers/shiftReducers";
import sidebarReducers from "./reducers/sidebarReducers";
import timesheetImportReducers from "./reducers/timesheetImportReducers";
import timesheetReducers from "./reducers/timesheetReducers";
import videoReducers from "./reducers/videoReducers";
import webinarReducers from "./reducers/webinarReducers";
import workLocationReducers from "./reducers/workLocationReducers";
import zktecoReducers from "@/integrations/zkteco/store/zktecoReducers";
import timemotoReducers from "@/integrations/timemoto/store/timemotoReducers";
import accountingReducers from "./reducers/accountingReducers";
import pensionIntegrationReducers from "@/integrations/pensionIntegrations/store/pensionIntegrationReducers";
import accountingIntegrationReducers from "@/integrations/accountingIntegrations/store/accountingIntegrationReducers";
import templateReducers from "./reducers/templateReducers";
import documentReducers from "./reducers/documentReducers";
import paymentIntegrationReducers from "../components/integrations/paymentIntegrations/store/paymentIntegrationReducers";
import advisorTaxFormReducers from "./reducers/advisorTaxFormReducers";

const defaultState = {
	showV2Reports: true,
	timesheets: {
		images: [],
		imagePreview: {},
		processing: false,
	},
	timesheetImport: {
		isModalOpen: false,
		employees: {},
		// TODO get conditions
		warningConditions: [
			{
				id: "NF",
				name: "Employee Reference Not Found.",
			},
			{
				id: "Leave",
				name: "Employee has Leave on this day.",
			},
			{
				id: "TimeOverlap",
				name: "Overlapping hours worked",
			},
			{
				id: 1,
				name: "Hours worked under 3 hours.",
				v1: ":hours",
				operand: "<",
				v2: "3",
			},
			{
				id: 2,
				name: "Hours worked more than 10 Hours",
				v1: ":totalHoursInDay",
				operand: ">",
				v2: 10,
				// v2: ":scheduled-duration"
			},
			{
				id: 3,
				name: "Maximum Break time exceeded",
				v1: ":breakDuration",
				operand: ">",
				v2: "1",
			},
			{
				id: 4,
				name: "Time-In Adjusted",
				v1: ":time-in-status",
				operand: "includes",
				v2: [5, 9],
			},
			{
				id: 5,
				name: "Time-Out Adjusted",
				v1: ":time-out-status",
				operand: "includes",
				v2: [5, 9],
			},
			{
				id: 6,
				name: "Manually Entered",
				v1: ":time-in-status",
				operand: "==",
				v2: "M",
			},
			{
				id: 7,
				name: "Corrections -ve hours",
				v1: ":time-in-status",
				operand: "==",
				v2: "S",
			},
		],
	},
	authentication: {},
	cola: {},
	employee: {
		employeeDetails: {},
		taxSettings: [],
		selectedTax: null,
		sentInvite: null,
	},
	advisors: {
		reports: {},
	},
	employees: {
		importModal: false,
	},
	my: {
		mfa: {
			setup: {},
		},
	},
	leave: {
		days: [0, 1, 2, 3, 4, 5, 6],
	},
	pensions: {
		scheme: {},
		group: {},
	},
	workLocation: {},
	leaveAdjustments: {
		adjustments: [],
	},
	grades: {},
	groups: [],
	allowances: {},
	overtimes: {},
	departments: {},
	costCenter: {},
	asset: {},
	deputy: {
		connected: false,
	},
	integration: {},
	documents: {},
	payment: {
		stripe: {},
		credits: [],
		transactionHistory: [],
	},
	payslipImport: {
		results: {},
	},
	leaveImport: {
		results: {},
	},
	leaveAdjustmentImport: {
		results: {},
	},
	notifications: {},
	payroll: {
		reopenPayrollModalOpen: false,
		payrollPage: "main",
		generatingReports: false,
		departmentExpanded: {},
		payPeriodDetails: {},
		generating: {
			all: false,
		},
	},
	payrollHistory: {
		isModalOpen: false,
	},
	organisation: {},
	video: {},
	scheme: {},
	group: {},
	createAccount: {
		userCreated: false,
		userUpdated: false,
		acLeadCreated: false,
		demoAccountCreated: false,
		data: {
			organisation: "",
			vatNo: "",
			door: "",
			street: "",
			city: "",
			postcode: "",
		},
	},
	payslipHistory: {},
	payPeriods: {},
	paySchedules: {
		payScheduleList: [],
	},
	sidebar: {
		show: true,
	},
	company: {
		resetPeriodTypeModal: {},
		gatewayPasswordModal: {},
		isCompanyModalOpen: false,
		isNewCompanyModalOpen: false,
		settings: {
			currency: "€",
			currencyName: "euro",
			jurisdiction: "MT",
			allowances: [],
			overtimes: [],
			paySchedules: [],
			departments: [],
		},
		loading: true,
		newCompany: {},
	},
	isNewEmployeeModalOpen: false,
	shifts: {
		current: {
			shifts: {},
		},
	},
	advisor: {},
	report: {
		filters: {
			startDate: new Date(),
			endDate: new Date(),
		},
	},
	newEmployee: {},
	admin: {},
	permissions: {},
	courseWebinarAttendanceImport: {},
	webinars: {
		list: [],
	},
	accounting: {
		fileImport: {},
		journals: {},
		ledgers: {},
		costCenters: {},
	},
};

const reducers = {
	//Integration reducers
	INTEGRATION: integrationReducers,
	// * Accounting
	XERO: xeroReducers,
	QUICKBOOKS: quickbooksReducers,
	VIFTO: viftoReducers,
	ACCOUNTING_INTEGRATION: accountingIntegrationReducers,
	// * HR
	BAMBOO: bambooReducers,
	// * Payment
	FYORIN: fyorinReducers,
	PAYMENT_INTEGRATION: paymentIntegrationReducers,
	// * Time & Attendance
	WORKFORCE: workforceReducers,
	DEPUTY: deputyReducers,
	ZKTECO: zktecoReducers,
	TIMEMOTO: timemotoReducers,
	// * Pension
	PENSION_INTEGRATION: pensionIntegrationReducers,
	PEOPLES_PENSIONS: peoplesPensionReducers,
	SMART_PENSION: smartPensionReducers,
	INTEGRATION: integrationReducers,

	// * Application reducers
	AUTHENTICATION: authenticationReducers,
	TIMESHEETS: timesheetReducers,
	EMPLOYEES: employeeReducers,
	EMPLOYEE: employeeReducers,
	LEAVE_ADJUSTMENT: leaveAdjustmentReducers,
	LEAVE: leaveReducers,
	PENSION: pensionReducers,
	WORKLOCATION: workLocationReducers,
	MY: myReducers,
	GRADE: gradeReducers,
	GROUP: groupReducers,
	SCHEME: schemeReducers,
	ALLOWANCE: allowanceReducers,
	OVERTIME: overtimeReducers,
	PAYROLL: payrollReducers,
	DEPARTMENT: departmentReducers,
	COSTCENTER: costCenterReducers,
	TIMESHEETIMPORT: timesheetImportReducers,
	PAYMENT: paymentReducers,
	CREATE_ACCOUNT: createAccountReducers,
	ORGANISATION: organisationReducers,
	VIDEO: videoReducers,
	FSSREPORT: fssReportReducers,
	PAYSLIP: payslipReducers,
	PAYPERIOD: payPeriodReducers,
	SIDEBAR: sidebarReducers,
	COMPANY: companyReducers,
	PAYSCHEDULE: payScheduleReducers,
	ASSET: assetReducers,
	SHIFTS: shiftReducers,
	NOTE: noteReducers,
	PERMISSION: permissionReducers,
	AUDIT_LOG: auditLogReducers,
	REPORT: reportReducers,
	ADVISORS: advisorReducers,
	ADMIN: adminReducers,
	NOTIFICATION: notificationReducers,
	COURSE: courseReducers,
	WEBINAR: webinarReducers,
	ACCOUNTING: accountingReducers,
	ADVISOR_TAX_FORM: advisorTaxFormReducers,
	TEMPLATE: templateReducers,
	DOCUMENT: documentReducers,
};

const mapActionToReducer = (actionType) => {
	const reducer = Object.entries(reducers).find(([key, value]) => {
		return `${actionType}`.indexOf(key) == 0;
	})?.[1];

	return reducer;
};

const reducer = (state = defaultState, action) => {
	// console.info("state", defaultState);
	// console.info("action", action);

	const reducer = mapActionToReducer(action?.type);

	if (reducer) return reducer(state, action);
	return state;
};

export default reducer;
